import React, {Component} from "react";
import TopEvents from "./TopEvents/TopEvents";
import LineWidget from "./LineWidget/Index";

class LeftMenu extends Component {
	render() {
		return (
			<div className="left-menu">
				<TopEvents/>
				<LineWidget />
			</div>
		);
	}
}

export default LeftMenu;


// WEBPACK FOOTER //
// ./src/app/components/LeftMenu.js